import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Pencil, Trash2, KeyRound } from "lucide-react";
import { ROLE_LABELS, roleBadgeClass, effectiveRole, hasPerm } from "@/lib/roles";
import { useAuth } from "@/context/AuthContext";

export function UsuariosTable({ items, selectedIds, onToggleSel, onToggleAllSel, onGenResetLink, onOpenEdit, onAskDelete }) {
  const { user } = useAuth();
  const canEdit = hasPerm(user, "users", "a");
  const canDel = hasPerm(user, "users", "e");
  return (
    <Card>
      <CardHeader><CardTitle>Usuários ({items.length})</CardTitle></CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-10">
                <input type="checkbox"
                  checked={selectedIds.size > 0 && selectedIds.size === items.length}
                  onChange={onToggleAllSel}
                  className="accent-orange-600 w-4 h-4" data-testid="chk-all-users" />
              </TableHead>
              <TableHead>Nome</TableHead><TableHead>Email</TableHead>
              <TableHead>Perfil do Usuário</TableHead><TableHead>Papel efetivo</TableHead>
              <TableHead>Empresas</TableHead><TableHead>Permissões</TableHead>
              <TableHead>Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.map((u) => {
              const eff = effectiveRole(u);
              const numEmps = (u.empresa_ids || []).length;
              return (
                <TableRow key={u.id} data-testid={`user-row-${u.id}`}
                  className={selectedIds.has(u.id) ? "bg-orange-50/60" : ""}>
                  <TableCell>
                    <input type="checkbox" checked={selectedIds.has(u.id)}
                      onChange={() => onToggleSel(u.id)} className="accent-orange-600 w-4 h-4"
                      data-testid={`chk-user-${u.id}`} />
                  </TableCell>
                  <TableCell className="font-medium">{u.nome}</TableCell>
                  <TableCell>{u.email}</TableCell>
                  <TableCell>
                    <span className={`px-2 py-1 rounded text-xs font-semibold ${roleBadgeClass(u.role)}`}
                      data-testid={`user-role-${u.id}`}>{ROLE_LABELS[u.role] || u.role}</span>
                  </TableCell>
                  <TableCell>
                    <span className={`px-2 py-1 rounded text-xs font-semibold ${roleBadgeClass(eff)}`}
                      data-testid={`user-eff-${u.id}`}
                      title={eff === "super_admin" ? "Acesso global (todas as empresas)" : `Restrito a ${numEmps} empresa(s)`}>
                      {ROLE_LABELS[eff] || eff}
                    </span>
                  </TableCell>
                  <TableCell>
                    <span className="text-xs text-muted-foreground">
                      {eff === "super_admin" ? "todas" : `${numEmps} vinculada(s)`}
                    </span>
                  </TableCell>
                  <TableCell>
                    <span className="text-xs text-muted-foreground">{(u.permissions || []).length} perm.</span>
                  </TableCell>
                  <TableCell>
                    <div className="flex gap-1">
                      <Button size="icon" variant="ghost" onClick={() => onGenResetLink(u)}
                        data-testid={`btn-reset-${u.id}`} title="Gerar link de recuperação de senha">
                        <KeyRound className="w-4 h-4 text-emerald-600" />
                      </Button>
                      {canEdit && <Button size="icon" variant="ghost" onClick={() => onOpenEdit(u)}
                        data-testid={`btn-edit-user-${u.id}`}>
                        <Pencil className="w-4 h-4 text-orange-600" />
                      </Button>}
                      {canDel && <Button size="icon" variant="ghost" onClick={() => onAskDelete(u)}>
                        <Trash2 className="w-4 h-4 text-rose-600" />
                      </Button>}
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
